import api from './api';

export const getMealPlans = async (start, end, scope) => {
  const response = await api.get('/meal-plans', { params: { start, end, scope } });
  return response.data;
};

export const getShoppingList = async (start, end, scope) => {
  const response = await api.get('/meal-plans/shopping-list', { params: { start, end, scope } });
  return response.data;
};

export const createMealPlan = async ({ recipe_id, planned_date, meal_type, notes }) => {
  const response = await api.post('/meal-plans', { recipe_id, planned_date, meal_type, notes });
  return response.data;
};

export const updateMealPlan = async (id, { planned_date, meal_type, notes }) => {
  const response = await api.put(`/meal-plans/${id}`, { planned_date, meal_type, notes });
  return response.data;
};

export const deleteMealPlan = async (id) => {
  const response = await api.delete(`/meal-plans/${id}`);
  return response.data;
};

export const MEAL_TYPES = ['breakfast', 'lunch', 'dinner', 'snack'];
